import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MaintenanceService } from '../../services/maintenance.service';
import { DatePipe } from '@angular/common';
import { LanguageService } from '../../services/language/language.service';

@Component({
  selector: 'oops-page',
  templateUrl: './oops-page.component.html',
  styleUrls: ['./oops-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DatePipe]
})
export class OopsPageComponent {
  protected maintenanceService = inject(MaintenanceService);
  protected languageService = inject(LanguageService);
}
